import React, { useState } from 'react';
import { useParams } from "react-router-dom";

import ButtonsHistory from "./shared/ButtonsHistory";
import MainToolbar from './MainToolbar';
import { t } from "./common/LocalizationProvider";

import { makeStyles } from '@material-ui/core/styles';
import Alert from "@material-ui/lab/Alert";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CircularProgress from "@material-ui/core/CircularProgress";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import {
    Tabs, Tab, Box, TextField, Button, FormControl, InputLabel,
    Select, MenuItem, Snackbar, Typography, Divider, Container, Hidden, useMediaQuery, useTheme
} from '@material-ui/core';
import SpeedIcon from '@material-ui/icons/Speed';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import {ChevronLeft, ChevronRight} from "@material-ui/icons";
import {cyberStyles} from "./cssShared/cyberTheme";
import ButtonsHistoryMobile from "./shared/ButtonsHistoryMobile";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
    drawerOpen: {
        width: theme.dimensions?.drawerWidthDesktop || 240, // replaced 'drawerWidth' constant
        flexShrink: 0,
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    },
    drawerClose: {
        width: 64, // replaced 'drawerCollapsedWidth' constant
        flexShrink: 0,
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    },
    container: {
        paddingBottom: theme.spacing(4),
        maxWidth: 1000,
        margin: '0 auto',
        width: '100%',
    },
    tabs: {
        padding: theme.spacing(2, 1),
        width: '100%',
        '& .MuiTabs-indicator': { display: 'none' }
    },
    buttonsHistory: {
        marginTop: 'auto',
        paddingBottom: 0,
        marginBottom: 0,
    },
    dualInput: {
        display: 'flex',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    actionFooter: {
        marginTop: 'auto',
        paddingTop: theme.spacing(3),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    loading: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(10, 14, 20, 0.8)',
        backdropFilter: 'blur(5px)',
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1),
        justifyContent: 'space-between',
        minHeight: 48,
        color: '#00f2ff',
    },
    mobileFooter: {
        position: 'fixed',
        bottom: 0,
        width: '100%',
        zIndex: 1000,
        backgroundColor: 'rgba(13, 22, 31, 0.95)',
        borderTop: '1px solid rgba(0, 242, 255, 0.2)',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} style={{ width: '100%' }} {...other}>
            {value === index && (<Box>{children}</Box>)}
        </div>
    );
}

const CommandsPage = () => {
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [type, setType] = useState(t("DeviceOverspeed"));
    const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [choice, setChoice] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');

    const { id } = useParams();
    let deviceId = parseInt(id);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    const handleChange = (event, newValue) => {
        setValue(newValue);
        if(newValue === 0) setType(t("DeviceOverspeed"))
        if(newValue === 1) setType(t("displacementalarm"))
        if(newValue === 2) setType(t("stopengine"))
        if(newValue === 3) setType(t("eventDeviceFuelDrop"))
        if(newValue === 4) setType(t("dimensions"))
        if(newValue === 5) setType(t("customnotifications"))
    };

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpenDialog(false);
    };

    const handleOpenSnackbar = () => setOpenSnackbar(true);

    const handleSend = async (e) => {
        e.preventDefault();
        setLoading(true)
        let description = "";

        switch (value) {
            case 0: description = JSON.stringify({maxSpeed: parseFloat(val)}); break;
            case 1: description = JSON.stringify({maxDisplacement:parseFloat(val)}); break;
            case 2: description = JSON.stringify({Keeyword:choice}); break;
            case 3: description = JSON.stringify({FuelDrop:parseFloat(val)}); break;
            case 4: description = JSON.stringify({radius:parseFloat(val), Lenght:parseFloat(val2)}); break;
            case 5: description = JSON.stringify({Keeyword:choice }); break;
            default: break;
        }

        const bodyContent = { type: "dimensions", deviceId, description, ...(value === 2 && { password })}

        const response = await fetch( 'api/cmd/send', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(bodyContent),
        });
        if (response.status === 200)
            setMessage("cmdSendSuccess")
        else if (response.status === 400){
            const errorText = await response.text();
            let spliteText = errorText.split(' ')[0];
            setMessage(spliteText)
        }
        else {
            setMessage('UnknownProblem')
        }
        handleOpenSnackbar()
        handleCloseDialog()
        setLoading(false)
    };

    const handleDrawerToggle = () => {
        setHideDrawer(!hideDrawer);
    };

    const drawerContent = (
        <>
            <div className={classes.toolbarSpacer} />
            <div className={classes.drawerHeader}>
                {!hideDrawer && (
                    <Typography variant="subtitle1" className={classes.drawerHeaderTitle} noWrap>
                        {t("commands")} / {type}
                    </Typography>
                )}
                <IconButton onClick={handleDrawerToggle} className={classes.toggleIcon}>
                    {hideDrawer ? <ChevronRight/> : <ChevronLeft />}
                </IconButton>
            </div>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                className={classes.tabs}
            >
                <Tab icon={<SpeedIcon />} className={classes.tabItem} label={hideDrawer ? "" : t("DeviceOverspeed")} />
                <Tab icon={<CompareArrowsIcon />} className={classes.tabItem} label={hideDrawer ? "" : t("displacementalarm")} />
                <Tab icon={<PowerSettingsNewIcon />} className={classes.tabItem} label={hideDrawer ? "" : t("stopengine")} />
                <Tab icon={<LocalGasStationIcon />} className={classes.tabItem} label={hideDrawer ? "" : t("eventDeviceFuelDrop")} />
                <Tab icon={<AspectRatioIcon />} className={classes.tabItem} label={hideDrawer ? "" : t("dimensions")} />
                <Tab icon={<NotificationsActiveIcon />} className={classes.tabItem} label={hideDrawer ? "" : t("customnotifications")} />
            </Tabs>
            <div className={classes.buttonsHistory}>
                <ButtonsHistory hideDrawer={hideDrawer}/>
            </div>
        </>
    );


    return (
        <div className={classes.settingRoot}>
            <CssBaseline />

            {!isMobile && <div className={classes.appBarWrapper}><MainToolbar/></div>}

            <Hidden smDown implementation="css">
                <Drawer
                    variant="permanent"
                    className={!hideDrawer ? classes.drawerOpen : classes.drawerClose}
                    classes={{
                        // FIX: Merge your primary drawerPaper style rules here
                        paper: clsx(classes.drawerPaper, {
                            [classes.drawerPaperOpen]: !hideDrawer,
                            [classes.drawerPaperClose]: hideDrawer,
                        }),
                    }}
                >
                    {drawerContent}
                </Drawer>
            </Hidden>

            <main className={classes.content} style={{marginTop: isMobile ? -80 : 0}}>
                <div className={classes.toolbarSpacer} style={{marginBottom: theme.spacing(2),}}/>
                <Container maxWidth="md" className={classes.container}>
                    <Hidden mdUp>
                        <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6" className={classes.sectionTitle}>
                                {t("commands")} / {type}
                            </Typography>
                        </Box>

                        <div className={classes.mobileTabContainer}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                orientation="vertical"
                                indicatorColor="secondary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label={t("DeviceOverspeed")} />
                                <Tab label={t("displacementalarm")} />
                                <Tab label={t("stopengine")} />
                                <Tab label={t("eventDeviceFuelDrop")} />
                                <Tab label={t("dimensions")} />
                                <Tab label={t("customnotifications")} />
                            </Tabs>
                        </div>
                    </Hidden>

                    <div className={isMobile ? classes.formWrapperMobile : classes.formWrapperDesktop}>
                        <div style={!isMobile ? { flex: 1 } : undefined}>
                            <Typography variant="h5" className={classes.sectionTitle} gutterBottom>
                                {type}
                            </Typography>

                            <TabPanel value={value} index={0}>
                                <TextField className={classes.inputField} value={val || ''} onChange={(e) => setVal(e.target.value)} label={`${t("valuein")} (${t("sharedKmh")})`} variant="outlined" />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <TextField className={classes.inputField} value={val || ''} onChange={(e) => setVal(e.target.value)} label={`${t("valuein")} (${t("sharedKm")})`} variant="outlined" />
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <FormControl variant="outlined" className={classes.inputField}>
                                    <InputLabel>{t('commandTitle')}</InputLabel>
                                    <Select
                                        value={choice}
                                        onChange={(e) => setChoice(e.target.value)}
                                        label={t('commandTitle')}
                                        MenuProps={{PaperProps: { className: classes.periodMenuPaper },}}
                                    >
                                        <MenuItem value={"motor_off"} className={classes.menuItem}>{t("stop")}</MenuItem>
                                        <MenuItem value={"motor_on"} className={classes.menuItem}>{t("start")}</MenuItem>
                                    </Select>
                                </FormControl>
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <TextField className={classes.inputField} value={val || ''} onChange={(e) => setVal(e.target.value)} label={`${t("valuein")} (${t("sharedLiter")})`} variant="outlined" />
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <div className={classes.dualInput}>
                                    <TextField variant="outlined" value={val || ''} onChange={(e) => setVal(e.target.value)} label={`${t("height")} (${t("sharedMeters")})`} className={classes.inputField} style={{maxWidth: 240}} />
                                    <TextField variant="outlined" value={val2 || ''} onChange={(e) => setVal2(e.target.value)} label={`${t("width")} (${t("sharedMeters")})`} className={classes.inputField} style={{maxWidth: 240}} />
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={5}>
                                <FormControl variant="outlined" className={classes.inputField}>
                                    <InputLabel>{t('sharedNotifications')}</InputLabel>
                                    <Select
                                        value={choice}
                                        onChange={(e) => setChoice(e.target.value)}
                                        label={t('sharedNotifications')}
                                        MenuProps={{PaperProps: { className: classes.periodMenuPaper },}}
                                    >
                                        <MenuItem value={"location"} className={classes.menuItem}>{t("sharedLocation")}</MenuItem>
                                        <MenuItem value={"speed"} className={classes.menuItem}>{t("positionSpeed")}</MenuItem>
                                    </Select>
                                </FormControl>
                            </TabPanel>
                        </div>

                        {!isMobile && <Divider style={{margin: '20px 0', backgroundColor: 'rgba(0, 242, 255, 0.1)'}}/>}

                        <div className={classes.actionFooter}>
                            <Button className={classes.sendButton} color='primary' variant='contained' onClick={() => setOpenDialog(true)}>
                                {t("send")}
                            </Button>
                        </div>
                    </div>

                </Container>
            </main>

            {isMobile && (
                <footer className={classes.mobileFooter}>
                    <ButtonsHistoryMobile hideDrawer={false}/>
                </footer>
            )}

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    style: { backgroundColor: '#0d161f', border: '1px solid #00f2ff', color: '#fff', borderRadius: '15px' }
                }}
            >
                <DialogTitle style={{color: '#00f2ff'}}>{t("confirmation")}</DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: 'rgba(255,255,255,0.7)'}}>{t("send message request")}</DialogContentText>
                    {value === 2 && (
                        <TextField
                            fullWidth
                            margin="normal"
                            value={password || ''}
                            onChange={(e) => setPassword(e.target.value)}
                            label={t("userPassword")}
                            variant="outlined"
                            type={showPassword ? 'text' : 'password'}
                            className={classes.inputField}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" style={{color: '#00f2ff'}}>
                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    )}
                    <Box mt={2} display="flex" justifyContent="flex-end" gridGap={8} pb={2}>
                        <Button onClick={() => setOpenDialog(false)} style={{color: '#fff'}}>{t("sharedCancel")}</Button>
                        <Button onClick={handleSend} className={classes.sendButton} variant='contained' disabled={loading}>
                            {loading ? <CircularProgress size={24} color="inherit" /> : t("send")}
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
                <Alert variant="filled" severity={message === "cmdSendSuccess" ? "success" : "error"}>
                    {t(message)}
                </Alert>
            </Snackbar>

            {loading &&
                <div className={classes.loading}>
                    <CircularProgress style={{color: '#00f2ff'}} size={60} thickness={4}/>
                </div>
            }
        </div>
    );
};

export default CommandsPage;